// @ts-ignore
import React, {useEffect, useRef} from "react";
import {AccordionDetails} from "@mui/material";

const AccordionDetailsCustom = ({component}: any): any => {
    const panel = useRef();

    // this will run after the component mounted.
    useEffect(() => {
        //console.log("Maunting panel", panel);
    }, []);

    return (
        <AccordionDetails ref={panel}>
            {component}
        </AccordionDetails>
    );
}

export default AccordionDetailsCustom;
